import { Navigate, useLocation } from "react-router-dom";

import { RVNestedRoutingPage } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { createRerouteRegex } from "App/routes/pageNames";
import { AppPagePaths, LegacyPagePaths } from "App/routes/paths";

import { useOrchestrationPathing } from "../../useOrchestrationPathing";

export default function JourneysRouter(): JSX.Element {
    const { orchestrationPages } = usePageAvailability();

    if (!orchestrationPages.showJourneys) {
        return <Navigate to={AppPagePaths.fallback} />;
    }

    return <RVNestedRoutingPage />;
}

export function JourneysRerouter(): JSX.Element {
    const location = useLocation();
    const { journeysBasePath } = useOrchestrationPathing();
    const pathAfterJourneys = location.pathname.replace(createRerouteRegex(LegacyPagePaths.journeys), "");
    const newPath = pathAfterJourneys
        ? `${journeysBasePath}/${pathAfterJourneys}${location.search}${location.hash}`
        : `${journeysBasePath}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
}
